import YaCounter from "../ym";
import VGMask from "../../../../../../modules/vegas/js/mask";

window.VegasCatalog.Cart = {
	add: function (id, cnt, params, callback) {
		params = params || {};
		params.id = id;
		params.cnt = cnt || 1;
		params._token = App.csrf;

		this.addRequest(params, callback);
	},

	addRequest: function (params, callback) {
		$.post('/cart/add_product', params, function (data) {
			if (typeof callback === 'function')
				callback(data);

			VegasCatalog.Cart.total(data);
			VegasCatalog.popup('Добавлено в корзину');

			new YaCounter().goal('add-to-cart');
		});
	},

	changeCnt: function (id, cnt, appendParams, callback) {
		let params = appendParams || {};
		params.id = id;
		params.cnt = cnt;
		params._token = App.csrf;
		params = VegasCatalog.Cart.formData(params);

		$.post('/cart/change_product', params, function (data) {
			if (typeof callback === 'function')
				callback(data);

			VegasCatalog.Cart.total(data);
		});
	},

	remove: function (id, callback) {
		let params = {};
		params.id = id;
		params._token = App.csrf;

		this.removeRequest(params, callback);
	},

	removeRequest: function (params, callback) {
		$.post('/cart/del_product', params, function (data) {
			if (typeof callback === 'function')
				callback(data);

			VegasCatalog.Cart.total(data);
			VegasCatalog.popup('Убрано из корзины');
		});
	},

	total: function (data) {
		if (typeof data.products_count !== 'undefined') {
			$('[data-cart][data-counter=products]').attr('data-cnt', data.products_count);
		}

		this.totalCartForm(data);
		this.totalCartProducts(data);
	},

	totalCartForm: function (data) {
		let $form = $('#form-cart');

		if ($form.length) {
			// products sum
			let $sProducts = $form.find('[data-sum="products"]');
			$sProducts.find('[data-sum-value]').text(output_roubles(data.sums.sum));

			// cart sum
			let $sCart = $form.find('[data-sum="total"]');
			$sCart.find('[data-sum-value]').text(output_roubles(data.sums.sum));

			// delivery sym
			let $sDelivery = $form.find('[data-sum="delivery"]');
			if (data.sums.sum_delivery !== null) {
				$sDelivery.find('[data-sum-value]')
					.text(
						isNaN(data.sums.sum_delivery) ? data.sums.sum_delivery : (
							data.sums.sum_delivery > 0 ? output_roubles(data.sums.sum_delivery) : 'бесплатно'
						)
					);
				$sDelivery.show();
			} else {
				$sDelivery.hide();
			}
		}
	},

	totalCartProducts: function (data) {
		let $cartProducts = $('.catalog-cart--products');
		if ($cartProducts.length && typeof data.products_totals !== 'undefined') {
			for(let i in data.products_totals) {
				let p = data.products_totals[i];

				$cartProducts.find('[data-product-cart-item][data-pivot_id="'+p.pivot_id+'"]')
					.find('.price-total')
					.text(output_roubles(p.price_total));
			}
		}
	},

	updateTotalAll: function () {
		$.get('/cart/get_totals', VegasCatalog.Cart.formData(), function (data) {
			VegasCatalog.Cart.total(data);
		});
	},

	formData: function (appendParams) {
		appendParams = appendParams || {};
		let resultParams = $('#form-cart').serializeArray();

		if (!resultParams.length) {
			resultParams.push({name: '_token', value: App.csrf});
		}

		for (let name in appendParams) {
			resultParams.push({name: name, value: appendParams[name]});
		}

		return resultParams;
	},
};

let $document = $(document),
	$formCart = $("#form-cart");

/** PRODUCT LIST **/
$document.on('click', '[data-product-item] [data-cart][data-action=add]', function () {
	let $product = $(this).closest('[data-product-item]'),
		id = $product.data('id');

	updStatusProduct($product, 1, 'add');
	VegasCatalog.Cart.add(id);

	return false;
});

$document.on('change-counter', '[data-product-item] [data-cart="qty"]', function () {
	let $product = $(this).closest('[data-product-item]'),
		id = $product.data('id'),
		cnt = parseInt($(this).find('[data-qty-cnt]').val()) || parseInt($(this).find('[data-qty-cnt]').text());

	updStatusProduct($product, cnt, 'change');

	VegasCatalog.Cart.changeCnt(id, cnt);

	return false;
});

$document.on('click', '[data-product-item] [data-qty=trash]', function () {
	let $product = $(this).closest('[data-product-item]'),
		id = $product.data('id');

	updStatusProduct($product, 0, 'remove');
	VegasCatalog.Cart.remove(id);

	return false;
});

/** PRODUCT SHOW **/
$document.on('click', '[data-product] [data-cart][data-action=add]', function () {
	let $product = $(this).closest('[data-product]'),
		id = $product.data('id');

	updStatusProduct($product, 1, 'add');
	updStatusProduct($document.find('[data-product-item][data-id="'+ id +'"]'), 1, 'add');
	VegasCatalog.Cart.add(id);

	return false;
});

$document.on('click', '[data-product] [data-qty=trash]', function () {
	let $product = $(this).closest('[data-product]'),
		id = $product.data('id');

	updStatusProduct($product, 0, 'remove');
	updStatusProduct($document.find('[data-product-item][data-id="'+ id +'"]'), 0, 'remove');
	VegasCatalog.Cart.remove(id);

	return false;
});

$document.on('change-counter', '[data-product] [data-cart="qty"]', function () {
	let $product = $(this).closest('[data-product]'),
		id = $product.data('id'),
		cnt = parseInt($(this).find('[data-qty-cnt]').val()) || parseInt($(this).find('[data-qty-cnt]').text());

	updStatusProduct($product, cnt, 'change');
	updStatusProduct($document.find('[data-product-item][data-id="'+ id +'"]'), cnt, 'change', true);

	VegasCatalog.Cart.changeCnt(id, cnt);

	return false;
});

/** PRODUCT CART **/
$document.on('click', '[data-product-cart-item] [data-cart][data-action="del"]', function () {
	let $product = $(this).closest('[data-product-cart-item]'),
		id = $product.data('id');

	VegasCatalog.Cart.remove(id, function () {
		$product.fadeOut(function () {
			$(this).remove();

			updStatusProduct($document.find('[data-product-item][data-id="'+ id +'"]'), 0, 'remove');

			let cnt = $('.catalog-cart--products [data-product-cart-item]').length;
			if (cnt === 0) {
				$document.find('.catalog-cart-total').fadeOut();
				$document.find('.catalog-cart-empty').addClass('show');
			}
		});
	});

	return false;
});

$document.on('change-counter', '[data-product-cart-item] [data-cart="qty"]', function () {
	let $product = $(this).closest('[data-product-cart-item]'),
		pivot_id = $product.data('pivot_id'),
		id = $product.data('id'),
		cnt = parseInt($(this).find('[data-qty-cnt]').text()),
		params = {
			pivot_id: pivot_id,
			get_products_totals: true
		};

	updStatusProduct($document.find('[data-product-item][data-id="'+ id +'"]'), cnt, 'change', true)

	VegasCatalog.Cart.changeCnt(0, cnt, params);

	return false;
});

// toggle form cart
$document.on('click', '[data-vg-toggle="cart"]', function () {
	let _self = $(this),
		target = _self.data('target'),
		$container = _self.closest('form');

	$container.find('[data-cart-block]').hide();
	$container.find('[data-cart-block="'+ target +'"]').show();

	request($container, target);

	function request($container, target) {
		let params = {
			_token: App.csrf
		};

		if (target === 'form') {
			let isLoad = $container.find('[data-cart-block="form"]').attr('data-load') !== 'false';

			if (!isLoad) {
				$.get('/cart/form', params, function (view) {
					$container.find('#vg-cart-form').html(view);

					let $selectAddress = $container.find('[name=user_address]');
					if ($selectAddress.length) {
						$selectAddress.select2({
							language: 'ru',
							ajax: {
								url: $selectAddress.data('ajaxurl'),
								data: function (params) {
									return {search: params.term};
								}
							},
							processResults: function (data) {
								return {
									results: data.items
								};
							}
						});

						$selectAddress.data('select2').$dropdown.find(':input.select2-search__field').attr('placeholder', $selectAddress.data('placeholder-search'));
					}

					// InputMask
					VGMask.init();
					$container.find('[data-cart-block="form"]').attr('data-load', 'true');
				});
			}

			$container.find('.vg-sidebar-back').show();
			$container.find('.vg-sidebar-title').text('Оформление заказа');
		} else {
			$container.find('.vg-sidebar-back').hide();
			$container.find('.vg-sidebar-title').text('Ваш заказ');
		}
	}

	return false;
});

function updStatusProduct ($product, cnt, status, isChangeCounter = false) {
	if (status === 'add') {
		$product.addClass('in-cart');
	} else if (status === 'remove') {
		$product.removeClass('in-cart');
	} else if (status === 'change') {
		let max = $product.data('max'),
			$stock = $product.find('[data-product-counter] .stock'),
			$btnPlus = $product.find('[data-qty="plus"]');

		if (cnt >= max) {
			$btnPlus.attr('disabled', true);
			$stock.addClass('show');
		} else {
			$btnPlus.removeAttr('disabled');
			$stock.removeClass('show');
		}

		if (isChangeCounter) {
			$product.find('[data-qty-cnt]').text(cnt);
		}
	}

	$product.find('[data-product-counter] .number').text(cnt);
}
